<template>
  <div class="authorize-links">
    <el-row
      type="flex"
      :gutter="20">
      <el-col :span="8">
        <a
          href="/personal?forgot_password=yes"
          class="authorize-links__item common-link">Забыли пароль?</a>
      </el-col>
      <el-col :span="16">
        <div
          v-if="isPhone"
          class="authorize-links__item transparent-link"
          @click="openPopup">Получить пароль по смс
        </div>
      </el-col>
    </el-row>
    <el-row
      type="flex"
      :gutter="20">
      <el-col :span="8">
        <a
          class="authorize-links__item common-link"
          @click="register">Регистрация</a>
      </el-col>
      <el-col :span="16">
        <div
          class="authorize-links__item link"
          @click="$emit('login')">Войти
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'AuthLinks',
  props: {
    isPhone: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('auth', [
      'getIsPopup'
    ])
  },
  methods: {
    ...mapMutations('auth', [
      'setIsPopup',
      'setPopupType'
    ]),
    openPopup: function () {
      this.setIsPopup(window.$(this.$el).parents('.auth-popup__background').length > 0)
      window.openPopupInputPhone()
    },
    register: function () {
      if (this.getIsPopup) {
        this.setPopupType('register')
      } else {
        window.location.href = '/personal?register=yes'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Auth/Authorize/AuthLinks.vue